export const API_URL = process.env.REACT_APP_API_URL;
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL;

// Helper function for media URLs
export const getMediaURL = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/uploads')) return `${UPLOADS_URL}${url}`;
  return `${UPLOADS_URL}/uploads/${url}`;
};